import { render, staticRenderFns } from "./ForgotPasswordChange.vue?vue&type=template&id=e6b37742&scoped=true&"
import script from "./ForgotPasswordChange.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordChange.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordChange.vue?vue&type=style&index=0&id=e6b37742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b37742",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VFlex,VForm,VRow,VSpacer,VTextField})
